import { render, staticRenderFns } from "./FaqQuestionComponent.vue?vue&type=template&id=ea567d40&scoped=true"
import script from "./FaqQuestionComponent.vue?vue&type=script&lang=js"
export * from "./FaqQuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./FaqQuestionComponent.vue?vue&type=style&index=0&id=ea567d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea567d40",
  null
  
)

export default component.exports